import { ButtonHTMLAttributes, FC } from 'react';
import clsx from 'clsx';
import styles from './ToggleButton.module.css';

interface ToggleButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
}

export const ToggleButton: FC<ToggleButtonProps> = ({
  active,
  className,
  ...props
}) => {
  return (
    <button
      className={clsx(styles.btn, { [styles.active]: active }, className)}
      {...props}
    />
  );
};
